import React from 'react';
import { Link } from 'react-router-dom';

interface CookieConsentProps {
  onAccept: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept }) => {
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    onAccept();
  };

  return (
    <div className="fixed inset-x-3 bottom-3 z-50 mx-auto flex max-w-3xl flex-col gap-3 rounded-lg bg-bl-black p-4 text-sm text-white shadow-2xl sm:flex-row sm:items-center sm:justify-between">
      <p className="text-white/80">
        We gebruiken cookies om de site te verbeteren. Meer lees je in ons{' '}
        <Link to="/privacy-policy" className="underline hover:text-white">
          privacybeleid
        </Link>
        .
      </p>
      <button type="button" onClick={handleAccept} className="btn bg-white px-5 py-2 text-bl-black hover:bg-bl-cream">
        Akkoord
      </button>
    </div>
  );
};

export default CookieConsent;
